import React, { Component } from 'react';
import { string } from '../../../../../localization';
import { connect } from 'react-redux';
import * as Constants from '../../../../../utilities/constants/Constants';
import '../../FinalCheck.scss';
import {
  convertFromImperialToMetric,
  getPremiumContentPrice,
  currencyConversion,
  convertImperialToGivenUnitSystem,
  getUniquePremiumContent,
  getArea,
  getAreaUnit
} from '../../../../../utilities/HelperFunctions/HelperFunctions';
import { checkIfCanvasApp, getUnit } from '../../../../../redux/homeActions';
import {
  getPlacings,
  isMaterialPriceSupported,
  pricePerSqft
} from '../../../../../redux/ProjectData/Project';
import _ from 'lodash';
import { shouldAddExternalContents } from '../../../../../redux/modalActions';
import { bindActionCreators } from 'redux';

class PriceDetails extends Component {
  state = {
    quantity: 1
  };

  setQuantity = item => {
    this.setState({ quantity: item });
  };

  getArrayId = item => `itemQuantity ${item}`;

  initializeArray = () => {
    const arr = [];
    for (let i = 0; i < 100; i++) {
      arr.push(i + 1);
    }
    return arr;
  };

  quantityChangeHandler = e => {
    this.setState({ quantity: e.target.value });
  };

  materialPrice = (width, height, unitSystem, pricePerUnitArea, quantity) => {
    if (unitSystem === Constants.METRIC_KEY) {
      return (
        ((convertFromImperialToMetric(width) *
          convertFromImperialToMetric(height)) /
          Constants.SQ_CENTIMETER_TO_SQ_METER) *
        pricePerUnitArea *
        quantity
      ).toFixed(2);
    }
    return (
      ((width * height) / Constants.SQ_INCHES_TO_SQ_FEET) *
      pricePerUnitArea *
      quantity
    ).toFixed(2);
  };

  // total poster price without vat
  totalMaterialPrice = () => {
    const sizeDetailsArray = this.getSizeDetailsArray();
    let total = 0;

    sizeDetailsArray.forEach(sizeDetail => {
      total += parseFloat(sizeDetail.materialPrice);
    });

    return total;
  };

  // Material price per unit area
  pricePerUnitAreaOfMaterial = (materials, index, unitSystem) => {
    const { themeResponseList, envData } = this.props;
    return pricePerSqft(
      themeResponseList,
      materials,
      index,
      unitSystem,
      envData.category,
      this.isExternalContentTheme()
    );
  };

  // Vat calculation; based on specified vat in backend settings
  vat = (totalMaterialPrice, premiumContentPrice, quantity, vat) =>
    (
      ((parseFloat(totalMaterialPrice) +
        parseFloat(quantity * premiumContentPrice)) *
        vat) /
      Constants.PERCENTAGE_KEY
    ).toFixed(2);

  // Grand total calulation
  getGrandTotal = (totalPrice, premiumContentPrice, vat, quantity, rounded) => {
    if (rounded) {
      return Math.round(
        parseFloat(totalPrice) +
          parseFloat(premiumContentPrice * quantity) +
          parseFloat(vat)
      ).toFixed(2);
    }
    return (
      parseFloat(totalPrice) +
      parseFloat(premiumContentPrice * quantity) +
      parseFloat(vat)
    ).toFixed(2);
  };

  // Currency positioning
  currencyPlacing = placement => {
    if (placement === Constants.BEFORE_PRICE_KEY) {
      return ' currency-before-price';
    }
    return ' currency-after-price';
  };

  getAllPlacings = () => {
    const { multiWallProjects, project } = this.props;
    const placings = [];
    if (multiWallProjects.length) {
      multiWallProjects.forEach(wallProject => {
        placings.push(getPlacings(wallProject));
      });
    } else {
      placings.push(getPlacings(project));
    }
    const temp = _.flatten(placings);
    return temp;
  };

  getSizeDetail = (projectWidth, projectHeight, unitSystem) => {
    const widthInCurrentUnitSystem = convertImperialToGivenUnitSystem(
      projectWidth,
      unitSystem
    );
    const heightInCurrentUnitSystem = convertImperialToGivenUnitSystem(
      projectHeight,
      unitSystem
    );

    const sizeDetails = `${widthInCurrentUnitSystem}${getUnit(
      unitSystem
    )} X ${heightInCurrentUnitSystem}
          ${getUnit(unitSystem)} (
          ${getArea(projectWidth, projectHeight, unitSystem)} 
          ${getAreaUnit(unitSystem)})`;
    return sizeDetails;
  };

  getSizeDetailsArray = () => {
    const {
      multiWallProjects,
      unitSystem,
      storeData,
      project,
      dispatchers
    } = this.props;
    const { quantity } = this.state;
    const sizeDetailsArray = [];
    if (multiWallProjects.length) {
      multiWallProjects.forEach(wallProject => {
        const sizeDetail = {
          id: wallProject.id,
          size: this.getSizeDetail(
            wallProject.width,
            wallProject.height,
            unitSystem
          ),
          materialPrice: parseFloat(
            this.materialPrice(
              wallProject.width,
              wallProject.height,
              unitSystem,
              this.pricePerUnitAreaOfMaterial(
                storeData.materials,
                this.getMaterialIndex(wallProject.materialId),
                unitSystem
              ),
              quantity
            )
          )
        };
        sizeDetailsArray.push(sizeDetail);
      });
    } else if (project.walls.length) {
      project.walls.forEach(wall => {
        let { width, height } = wall;
        if (dispatchers.checkIfCanvasApp()) {
          width = project.width;
          height = project.height;
        }
        const sizeDetail = {
          id: wall.id,
          size: this.getSizeDetail(width, height, unitSystem),
          materialPrice: parseFloat(
            this.materialPrice(
              width,
              height,
              unitSystem,
              this.pricePerUnitAreaOfMaterial(
                storeData.materials,
                this.getMaterialIndex(project.materialId),
                unitSystem
              ),
              quantity
            )
          )
        };
        sizeDetailsArray.push(sizeDetail);
      });
    }
    return sizeDetailsArray;
  };

  getMaterialIndex = materialId => {
    const { storeData } = this.props;
    let tempMaterialIndex = 0;
    if (materialId != null) {
      storeData.materials.forEach((element, index) => {
        if (element.id === materialId) {
          tempMaterialIndex = index;
        }
      });
    }
    return tempMaterialIndex;
  };

  showQuantity = () => false;

  isExternalContentTheme = () => {
    const { storeData, envData } = this.props;
    const {
      useOwnContent,
      contentHostingSite,
      externalContentSite
    } = storeData;
    const wallartLiteExternalContent = envData.wallart_lite_external_content;
    const wallartLiteWebLink = envData.wallart_lite_web_link;

    return shouldAddExternalContents(
      useOwnContent,
      contentHostingSite,
      externalContentSite,
      wallartLiteExternalContent,
      wallartLiteWebLink
    );
  };

  render() {
    const {
      onEditMaterial,
      unitSystem,
      storeData,
      applicationName,
      project,
      multiWallProjects,
      themeResponseList,
      dispatchers
    } = this.props;
    const { quantity } = this.state;
    const arr = this.initializeArray();

    const totalMaterialPrice = this.totalMaterialPrice();

    let premiumContentPrice = 0;
    let uniquePremiumContents = [];
    if (multiWallProjects.length) {
      multiWallProjects.forEach(wallProject => {
        const placings = [];
        let projectUniquePremiumContents = [];
        placings.push(getPlacings(wallProject));
        projectUniquePremiumContents = getUniquePremiumContent(
          _.flatten(placings)
        );
        uniquePremiumContents.push(projectUniquePremiumContents);
        uniquePremiumContents = _.flatten(uniquePremiumContents);
        premiumContentPrice += getPremiumContentPrice(
          projectUniquePremiumContents,
          storeData.conversionUnitEur,
          storeData.conversionUnitUsd
        );
      });
    } else {
      uniquePremiumContents.push(getUniquePremiumContent(getPlacings(project)));
      uniquePremiumContents = _.flatten(uniquePremiumContents);
      premiumContentPrice = getPremiumContentPrice(
        uniquePremiumContents,
        storeData.conversionUnitEur,
        storeData.conversionUnitUsd
      );
    }

    const totalVat = this.vat(
      totalMaterialPrice,
      premiumContentPrice,
      quantity,
      storeData.vat
    );

    const getGrandTotal = this.getGrandTotal(
      totalMaterialPrice,
      premiumContentPrice,
      totalVat,
      quantity,
      storeData.roundupPrice
    );

    return (
      <div>
        <div id='PriceDetails'>
          <div className='title arrow-cursor pt-2'>
            {string.MODEL_TITLE_KEY}
          </div>
          <div className='app-name text-uppercase'>{applicationName}</div>
          <div>
            {this.getSizeDetailsArray().map(sizeDetail => (
              <div
                className='d-flex justify-content-between'
                key={sizeDetail.id}
              >
                <div className='arrow-cursor'>{sizeDetail.size}</div>
                <div className='d-flex'>
                  {this.showQuantity() ? (
                    <div className='d-flex'>
                      <text className='arrow-cursor'>
                        {' '}
                        {string.OBJECT_QUANTITY_KEY}
                      </text>
                      <div className='btn-group' id='drop-down'>
                        <div className='quantity'>{quantity}</div>
                        <button
                          type='button'
                          label='dropdown'
                          className='dropper'
                          id='dropdownMenuReference'
                          data-toggle='dropdown'
                          aria-haspopup='true'
                          aria-expanded='false'
                          data-reference='parent'
                        />
                        <div
                          className='dropdown-menu dd-menu'
                          aria-labelledby='dropdownMenuReference'
                        >
                          {arr.map(item => (
                            <t
                              className='dropdown-item'
                              key={this.getArrayId(item)}
                              onClick={() => this.setQuantity(item)}
                            >
                              {item}
                            </t>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {!storeData.hidePricing ? (
                    <div
                      className={`price${this.currencyPlacing(
                        storeData.placeMsrpCurrency
                      )}`}
                    >
                      <div className='pl-1'>{sizeDetail.materialPrice}</div>
                      <div className='pl-1'> {storeData.msrpCurrency}</div>
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>

          <hr />

          <div>
            {isMaterialPriceSupported(
              themeResponseList,
              this.isExternalContentTheme()
            ) ? (
              <>
                <div className='title arrow-cursor pt-2 pb-2'>
                  {string.DESIGN_KEY}
                </div>
                <text className='arrow-cursor'>
                  {string.MATERIAL_TITLE_KEY}
                </text>
                <div className='justify-content-between pt-2'>
                  {multiWallProjects.length ? (
                    multiWallProjects.map((multiWallProject, index) => (
                      <div
                        className='d-flex justify-content-between'
                        key={multiWallProject.id}
                      >
                        <div className='d-flex arrow-cursor'>
                          {
                            storeData.materials[
                              this.getMaterialIndex(multiWallProject.materialId)
                            ].name
                          }
                          {storeData.materials.length > 1 ? (
                            <div
                              role='button'
                              tabIndex='0'
                              className='edit'
                              onKeyPress={() => {}}
                              onClick={() => onEditMaterial(index)}
                            >
                              {string.EDIT_LOWERCASE_KEY}
                            </div>
                          ) : null}
                        </div>
                        {!storeData.hidePricing ? (
                          <div className='price arrow-cursor'>
                            <div className='d-flex'>
                              <div
                                className={this.currencyPlacing(
                                  storeData.placeMsrpCurrency
                                )}
                              >
                                <div className='pl-1'>
                                  {this.pricePerUnitAreaOfMaterial(
                                    storeData.materials,
                                    this.getMaterialIndex(
                                      multiWallProject.materialId
                                    ),
                                    unitSystem
                                  )}
                                </div>
                                <div className='pl-1'>
                                  {storeData.msrpCurrency}
                                </div>
                              </div>
                              {getAreaUnit(unitSystem)}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ))
                  ) : (
                    <div className='d-flex justify-content-between'>
                      <div className='d-flex arrow-cursor'>
                        {
                          storeData.materials[
                            this.getMaterialIndex(project.materialId)
                          ].name
                        }
                        {storeData.materials.length > 1 ? (
                          <div
                            role='button'
                            tabIndex='0'
                            className='edit'
                            onKeyPress={() => {}}
                            onClick={() => onEditMaterial()}
                          >
                            {string.EDIT_LOWERCASE_KEY}
                          </div>
                        ) : null}
                      </div>
                      {!storeData.hidePricing ? (
                        <div className='price arrow-cursor'>
                          <div className='d-flex'>
                            <div
                              className={this.currencyPlacing(
                                storeData.placeMsrpCurrency
                              )}
                            >
                              <div className='pl-1'>
                                {this.pricePerUnitAreaOfMaterial(
                                  storeData.materials,
                                  this.getMaterialIndex(project.materialId),
                                  unitSystem
                                )}
                              </div>
                              <div className='pl-1'>
                                {storeData.msrpCurrency}
                              </div>
                            </div>
                            {getAreaUnit(unitSystem)}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
                <hr />
              </>
            ) : null}
            {dispatchers.checkIfCanvasApp() ? (
              <div className='pt-2'>
                <text className='arrow-cursor'>FINISHING</text>
                <div className=' pt-2'>{project.canvasFrameType}</div>
                <hr />
              </div>
            ) : null}
            {uniquePremiumContents.length !== 0 ? (
              <div className='arrow-cursor'>
                {string.IMAGES_TITLE_KEY}
                {uniquePremiumContents.map(item => (
                  <div className='d-flex justify-content-between pt-2'>
                    <div className='d-flex'>
                      <img
                        className='thumb-nail'
                        src={item.placeable.thumbnailPath}
                        alt='img'
                      />
                      <span className='premium-content-label'>
                        {item.placeable.title}
                      </span>{' '}
                      <span className='from-text'>from </span>{' '}
                      <span>{item.placeable.imageSource}</span>
                    </div>
                    {!storeData.hidePricing ? (
                      <div
                        className={`price${this.currencyPlacing(
                          storeData.placeMsrpCurrency
                        )}`}
                      >
                        <div className='pl-1'>
                          {' '}
                          {currencyConversion(
                            item.placeable,
                            storeData.conversionUnitEur,
                            storeData.conversionUnitUsd
                          ).toFixed(2)}
                        </div>{' '}
                        <div className='pl-1'>{storeData.msrpCurrency}</div>
                      </div>
                    ) : null}
                  </div>
                ))}
                <hr />
              </div>
            ) : null}
          </div>
        </div>
        {storeData.vat && !storeData.hidePricing ? (
          <div className='vat '>
            <span>{string.VAT_KEY}</span> ({storeData.vat}%):{' '}
            <div
              className={`price pl-4${this.currencyPlacing(
                storeData.placeMsrpCurrency
              )}`}
            >
              <div className='pl-1'> {totalVat}</div>
              <div className='pl-1'> {storeData.msrpCurrency}</div>
            </div>{' '}
          </div>
        ) : null}
        {!storeData.hidePricing ? (
          <div className='Container-text-total'>
            <p className='text-total'>
              <text className='pr-2'>{string.TOTAL_KEY}</text>
              <div
                className={this.currencyPlacing(storeData.placeMsrpCurrency)}
              >
                {getGrandTotal}
                <div className='pl-1 pr-1'> {storeData.msrpCurrency}</div>
              </div>
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectWidth: state.home.projectWidth,
    projectHeight: state.home.projectHeight,
    unitSystem: state.home.unitSystem,
    storeData: state.modal.storeData,
    envData: state.modal.envData,
    themeResponseList: state.modal.themeResponseList,
    materialIndex: state.sideBar.materialIndex,
    project: state.finalCheck.project,
    multiWallProjects: state.finalCheck.multiWallProjects
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: bindActionCreators({ checkIfCanvasApp }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PriceDetails);
